module.exports = __webpack_public_path__ + "img/clos-menu.6a64343e.svg";